import type { AssistantArtifact } from './types'

type ArtifactResult = {
  share_url?: string | null
  document_url?: string | null
  invoice?: {
    document_url?: string | null
    hosted_invoice_url?: string | null
    pay_url?: string | null
    pdf_url?: string | null
  } | null
}

/** Links to what a publication, delivery or invoice action produced (demo `assistant-artifacts`). */
export function assistantArtifactLinks(artifacts: AssistantArtifact[] = []) {
  const links = new Map<string, { label: string; href: string; document: boolean }>()
  for (const artifact of artifacts) {
    const invoice = ['create_invoice', 'send_invoice'].includes(artifact.kind)
    if (!invoice && !['publication', 'send_quote'].includes(artifact.kind)) continue
    const result = artifact.result as ArtifactResult
    const value = invoice ? result.invoice : result
    if (!value) continue
    const candidates = [
      {
        label: invoice ? 'Open invoice' : 'Open quote',
        href: invoice ? (result.invoice?.pay_url ?? result.invoice?.hosted_invoice_url) : result.share_url,
        document: false,
      },
      {
        label: invoice ? 'Download invoice' : 'Download quote',
        href: invoice ? (result.invoice?.pdf_url ?? result.invoice?.document_url) : value.document_url,
        document: true,
      },
    ]
    for (const link of candidates) {
      // Only returned web/app paths, never executable schemes or protocol-relative URLs.
      // eslint-disable-next-line no-control-regex
      if (typeof link.href === 'string' && /^(?:https?:\/\/|\/(?!\/))/.test(link.href) && !/[\\\u0000- ]/.test(link.href)) {
        links.set(link.href, { ...link, href: link.href })
      }
    }
  }
  return [...links.values()]
}
